import { procurementAPI } from "../../axios";

export const actions = {

    //RfqItem
    GetRfqItems(context, data){
        return procurementAPI.get(`RfqItem/Rfq/${data}`);
    },
    GetMigrationItems(context, data){
        return procurementAPI.get(`RfqItem/Migration/${data}`);
    },
    GetAvailablePRs(context, data){
        return procurementAPI.get(`RfqItem/Available/${data.campusId}/${data.cycle}`);
    },
    GetCanceledPRs(context, data){
        return procurementAPI.get(`RfqItem/Cancelled/${data.campusId}/${data.cycle}`);
    },
    GetSingleRfqItem(context, data){
        return procurementAPI.get(`RfqItem/${data}`);
    },
    UpdateRfqItem(context, data){
        return procurementAPI.put(`RfqItem/Update/${data.id}`, data.RfqItemDetails);
    },
    DeleteRfqItem(context, data){
        return procurementAPI.delete(`RfqItem/${data}`);
    },
    DeleteMigrationItem(context, data){
        return procurementAPI.delete(`RfqItem/Migration/${data}`);
    },
    CreateRfqItem(context, data){
        return procurementAPI.post(`RfqItem/Add/${data.campusId}`, data);
    },
    CreateSingleRfqItem(context, data){
        return procurementAPI.post(`RfqItem/Add/Single`, data);
    },
    ReawardRfqItem(context, data){
        return procurementAPI.put(`RfqItem/ReAward/${data.id}/${data.value}`);
    },
    UpdateSorting(context, data){
        return procurementAPI.post(`RfqItem/Sort`, data);
    },
}